import addMarkdown from 'global/markdown/simplemde-getresponse.src';
import formValidation from 'global/form-validation/1.7.0/es6/core/Core';
import Bootstrap3 from 'global/form-validation/1.7.0/es6/plugins/Bootstrap3';
import DefaultSubmit from 'global/form-validation/1.7.0/es6/plugins/DefaultSubmit';
import SubmitButton from 'global/form-validation/1.7.0/es6/plugins/SubmitButton';
import Declarative from 'global/form-validation/1.7.0/es6/plugins/Declarative';
import Trigger from 'global/form-validation/1.7.0/es6/plugins/Trigger';
import AutoFocus from 'formvalidation/es6/plugins/AutoFocus';
import Recaptcha from 'global/form-validation/1.7.0/es6/plugins/Recaptcha';
import scrollToElement from 'scroll-to-element';
import $ from 'jquery';
import 'select2';

(function ready(fn) {
    if (document.readyState !== 'loading') {
        fn();
    } else {
        document.addEventListener('DOMContentLoaded', fn);
    }
}(() => {
    loadData();
    addMarkdown();
    [].forEach.call(document.querySelectorAll('.multiselect'), initSelect2);
    let filesClone;

    // validator options
    const plugins = {
        trigger: new Trigger({
            event: 'blur change',
        }),
        bootstrap3: new Bootstrap3(),
        defaultSubmit: new DefaultSubmit(),
        submitButton: new SubmitButton(),
        declarative: new Declarative({
            html5Input: true,
        }),
        autoFocus: new AutoFocus(),
    };
    if (document.getElementById('captcha_container')) {
        plugins.recaptcha = new Recaptcha({
            element: 'captcha_container',
            siteKey: '6LdXyp0UAAAAABMqylYVIyo4xxeV-tDkoXh8rNFg',
            message: document.getElementById('captcha_container').getAttribute('data-fv-not-empty___message'),
            size: 'invisible',
        });
    }

    // init form validator
    const fv = formValidation(document.getElementById('submit_form'), {
        plugins,
    }).on('core.form.valid', () => {
        document.querySelector('#submit_form [name="integrations[submit]"]').disabled = true;
    });

    // images dimension validator options
    window.URL = window.URL || window.webkitURL;
    const imagesOptions = {
        validators: {
            promise: {
                promise(value, validator, $field) {
                    const dfd = new $.Deferred();
                    const files = $field[0].files || [];

                    if (files.length == 0) {
                        dfd.resolve({ valid: true });
                        return dfd.promise(); // quit
                    }

                    let count = 0;
                    for (let i = 0; i < files.length; i++) {
                        var img = new Image();
                        const file = files[i];

                        img.onload = function () {
                            const w = this.naturalWidth || this.width;
                            const h = this.naturalHeight || this.height;

                            window.URL.revokeObjectURL(img.src);
                            if (($field.attr('name') == 'form[logo]' && (w < 760 && h < 280))) {
                                dfd.reject({
                                    message: $field.attr('data-fv-promise-message'),
                                });
                                return dfd.promise(); // quit
                            }

                            count += 1;
                            if (count == files.length) {
                                // console.log('done');
                                dfd.resolve({ valid: true });
                            }
                        };
                        img.onerror = function () {
                            dfd.reject({
                                message: $field.attr('data-fv-message'),
                            });
                            return dfd.promise(); // quit
                        };
                        img.src = window.URL.createObjectURL(file);
                    }
                    return dfd.promise();
                },
            },
        },
    };

    // add dimension validation for file inputs
    [].forEach.call(document.querySelectorAll('[type="file"]'), (fileElement) => {
        fv.addField(fileElement, imagesOptions);
    });

    // list uploaded file names
    document.getElementById('submit_form').addEventListener('change', (e) => {
        if (e.target.matches('[type="file"]')) {
            const fileElement = $(e.target);
            // console.log('changed files: ', fileElement[0].files.length);
            if (fileElement[0].files.length === 0 && typeof (filesClone) !== 'undefined' && filesClone != null) {
                // console.log('no files, put clone, remove original', filesClone);
                filesClone.insertBefore(fileElement);
                fv.removeField(fileElement);
                fileElement.remove();
                fv.addField(filesClone, imagesOptions);
            } else {
                const imagesData = fileElement[0].files || [];
                fileElement.parent().find('.files').empty();
                // console.log('new files: ', fileElement[0].files.length)
                for (let i = 0; i < imagesData.length; i++) {
                    fileElement.parent().find('.files').append(`${imagesData[i].name}<br>`);
                }
            }
        }
    });

    // make clone with files
    document.getElementById('submit_form').addEventListener('click drop', (e) => {
        if (e.target.matches('[type="file"]')) {
            const fileElement = e.target;
            // console.log('clicked/draged: ', fileElement[0].files.length);
            if (fileElement[0].files.length !== 0) {
                // console.log('not empty, make clone');
                filesClone = (fileElement).cloneNode(true);
                // console.log('cloned: ', clone);
            }
        }
    });

    // keep form data in localStorage
    document.getElementById('submit_form').addEventListener('submit', () => {
        const formData = $(this).serializeArray();
        for (let i = 0; i < formData.length; i++) {
            if (formData[i].value === '') { // remove empty
                formData.splice(i, 1); i -= 1;
            } else if (formData[i].name === '_token') { // remove token
                formData.splice(i, 1); i -= 1;
            } else if (formData[i].name === 'g-recaptcha-response') { // remove captcha
                formData.splice(i, 1); i -= 1;
            }
        }
        localStorage.setItem('submitForm', JSON.stringify(formData));
    });

    // if back from thank you page to send next offer
    let nextOffer = (window.location.href).split('?')[1];
    if (nextOffer !== undefined) {
        nextOffer = nextOffer.split('#')[0];
        if (nextOffer === 'next=1') {
            // $('html,body').animate({ scrollTop: 0 }, 'slow');
            scrollToElement(document.querySelector('.bar'), {
                offset: 0,
                duration: 600,
            });
        }
    }

    // load back saved form data
    function loadData() {
        if (localStorage.getItem('submitForm') !== null) {
            const storedSubmitForm = JSON.parse(localStorage.getItem('submitForm'));
            const categories = [];
            const goals = [];
            for (let i = 0; i < storedSubmitForm.length; i++) {
                if (storedSubmitForm[i].name === 'integrations[categories][]') { // categories multiselect
                    categories.push(storedSubmitForm[i].value);
                } else if (storedSubmitForm[i].name === 'integrations[goal][]') { // goals multiselect
                    goals.push(storedSubmitForm[i].value);
                } else if (storedSubmitForm[i].value !== '') { // all other
                    document.querySelector(`[name="${storedSubmitForm[i].name}"]`).value = storedSubmitForm[i].value;
                }
            }
        }
    }

    function initSelect2(el) {
        const multiExtra = $(el).parent().find('.multiple-choice-extra');
        const elSelect = $(el).find('select');
        elSelect.select2({
            dropdownParent: $(el).closest('.multiselect'),
            closeOnSelect: false,
            width: 'resolve',
        }).on('change.select2', () => {
            fv.revalidateField(elSelect.attr('name'));
        });

        elSelect.on('select2:opening select2:closing', () => {
            const $searchIn = $(el).parent().find('.select2-search__field');
            $searchIn.prop('disabled', true);
        });
        elSelect.on('select2:open', () => {
            if (!elSelect.children('.multiple-choice-extra').length) {
                $(el).parent().find('.select2-dropdown').append(multiExtra);
            }
        });
        elSelect.on('change', () => {
            // refresh dropdown position
            $('html,body').trigger('scroll');
        });
        $(el).parent().find('.multiple-choice-all').on('click', () => {
            const all = $.map(elSelect.find('option'), (option) => option.value);
            elSelect.val(all).trigger('change').select2('close');
        });
        $(el).parent().find('.multiple-choice-apply').on('click', () => {
            elSelect.select2('close');
        });
        $(el).parent().find('.multiple-choice-cancel-in').on('click', () => {
            // unselect all, refresh labels, refresh checkboxes
            elSelect.val(null).trigger('change').select2('close');
        });
        elSelect.on('select2:unselect', () => {
            elSelect.select2('open');
        });
    }

    [].forEach.call(document.querySelectorAll('.select2-selection'), (element, i) => {
        element.setAttribute('data-ats', `select2-selection-${i + 1}`);
    });
}));
